const { h, render, Component } = require('preact');
const StatusInfo = require('./status_info')
const TradeInStatus = require('./trade_in_status')
const GiftStatus = require('../../containers/status/gift_status')

  class RegularOrderStatus extends Component {
    constructor() {
      super();
    }

    render({order}) {
      return (<div>
                <StatusInfo order={order}/>
                <TradeInStatus order={order} />
                <GiftStatus order={order} />
              </div>)
    }

}

module.exports = RegularOrderStatus
